import { classNames } from "./Utils/classNames.ts";

export type StatusBadgeTone =
  | "neutral"
  | "info"
  | "success"
  | "warning"
  | "danger";

const classesByTone: Record<StatusBadgeTone, string> = {
  neutral: "bg-slate-100 text-slate-700",
  info: "bg-blue-100 text-blue-800",
  success: "bg-emerald-100 text-emerald-800",
  warning: "bg-amber-100 text-amber-800",
  danger: "bg-red-100 text-red-800",
};

export function StatusBadge({
  tone,
  label,
}: {
  tone: StatusBadgeTone;
  label: string;
}) {
  return (
    <span
      className={classNames(
        "inline-flex whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium",
        classesByTone[tone],
      )}
    >
      {label}
    </span>
  );
}
